import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Backdrop } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { useAuthContext } from '../context/AuthProvider';
import Navbar from '../components/common/Navbar';
import Header from '../components/common/Header';
import JKLoader from '../components/common/JKLoader';
import RouteFallback from '../components/common/RouteFallback';

const DashboardLayout = () => {
  const { contextLoading } = useAuthContext();

  // No auth check here: ProtectedRoute wraps this layout in App.jsx, so nothing
  // renders it without a session. Keeping the guard in one place stops the two
  // from disagreeing about what "signed in" means.

  return (
    <div
      style={{
        backgroundColor: '#F8F8F8',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Header />
      <Navbar />
      {contextLoading && (
        <Backdrop
          open
          sx={{
            color: '#fff',
            zIndex: 99999,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          }}
        >
          <JKLoader />
        </Backdrop>
      )}
      {/* Fills the remaining viewport; the routed page manages its own scroll. */}
      <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Suspense fallback={<RouteFallback contentOnly />}>
          <Outlet />
        </Suspense>
      </div>
      <Toaster />
    </div>
  );
};

export default DashboardLayout;
